module.exports = __webpack_public_path__ + "img/one.63938b90.png";